var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center w-1/2",class:{
    'justify-start': !_vm.isNext,
    'justify-end': _vm.isNext,
  }},[_c('button',{staticClass:"bg-black text-white hover:text-orange-500 text-3xl font-bold rounded-full w-16 h-16 focus:outline-none z-20",class:{
      '-ml-8': !_vm.isNext,
      '-mr-8': _vm.isNext,
    },on:{"click":function($event){_vm.isNext ? _vm.next() : _vm.prev()}}},[_vm._v(" "+_vm._s(_vm.arrow)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }